var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-list"},_vm._l((_vm.list),function(item,index){return _c('div',{key:`news-${item.slug}-${index}`,staticClass:"news-list__item"},[_c('news-item',{attrs:{"item":item,"view":_vm.specialList.includes(index) ? 'news-full' : 'news-medium'}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }